import { render, staticRenderFns } from "./PageTakeAPhoto.vue?vue&type=template&id=0bd3d06f"
import script from "./PageTakeAPhoto.vue?vue&type=script&lang=js"
export * from "./PageTakeAPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports